// App.js - Clean Working Version
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Import components
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Register from './components/Register';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';
import Dashboard from './components/Dashboard';
import TeamCreation from './components/TeamCreation';
import QuizComponent from './components/QuizComponent';
import TeamDashboard from './components/TeamDashboard';
import AdminPanel from './components/AdminPanel';
import TeamComparison from './components/TeamComparison';
import HandleidingTherapeut from './components/HandleidingTherapeut';
import HandleidingClient from './components/HandleidingClient';
import FAQ from './components/FAQ';
import DataImport from './components/DataImport';
import UserProfile from './components/UserProfile';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '4px solid #e0f2fe',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ color: '#64748b' }}>Laden...</p>
        </div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '4px solid #e0f2fe',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ color: '#64748b' }}>Laden...</p>
        </div>
      </div>
    );
  }
  
  return user ? <Navigate to="/dashboard" replace /> : children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          
<Route path="/register" element={<Register />} />
<Route path="/reset-password" element={<ResetPassword />} />
          
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/quiz/:inviteCode" element={<QuizComponent />} />

          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          <Route path="/create-team" element={
            <PrivateRoute>
              <TeamCreation />
            </PrivateRoute>
          } />
          
          <Route path="/dashboard/:teamId" element={
            <PrivateRoute>
              <TeamDashboard />
            </PrivateRoute>
          } />
          
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/team-comparison" element={
            <PrivateRoute>
              <TeamComparison />
            </PrivateRoute>
          } />
          <Route path="/team-creation" element={<Navigate to="/create-team" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />

         <Route path="/handleiding-therapeut" element={<HandleidingTherapeut />} />
<Route path="/handleiding-client" element={<HandleidingClient />} />
<Route path="/faq" element={<FAQ />} />
<Route path="/import" element={<DataImport />} />
<Route path="/profiel" element={
  <PrivateRoute>
    <UserProfile />
  </PrivateRoute>
} />

        </Routes>
      </Router>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </AuthProvider>
  );
}

export default App;